/**
 * Auto linkify urls, #hashtags and @mentions when page is loaded
 */

import 'linkifyjs';
import 'linkify-plugin-hashtag';
import 'linkify-plugin-mention';
import linkifyHtml from 'linkify-html';
import linkifyString from 'linkify-string';

window.linkify = function(html, typesString, escapeHtml) {

    // default types to linkify
    var types = [
        // 'email', // don't auto link email globally
        'hashtag',
        'mention',
        'url',
    ];

    // check if we were provided a comma separated list of types to linkify
    if(typeof typesString === 'string' && typesString.length > 0){
        types = typesString.split(",");
    }

    // return true if the hashtag value is allowed to be auto linked
    function validateHashtag(value) {
        return /\B(#[a-zA-Z0-9]+(?!-)\b)/.test(value);
    }

    var config = {
        validate: {
            email: types.includes('email'),
            hashtag: function(value) {
                return types.includes('hashtag') && validateHashtag(value);
            },
            mention: types.includes('mention'),
            url: types.includes('url'),
        },
        rel: {
            url: 'nofollow noreferrer noopener', // prevent tracking by external links
        },
        target: {
            email: '_blank', // open emails in new tab
            hashtag: null, // open hashtags in current tab
            mention: null, // open mentions in current tab
            url: '_blank', // open urls in new tab
        },
        formatHref: {

            // Auto link #tag to hashtag page
            hashtag: function(val){
                var hashtag = val.substr(1); // strip leading #
                return window.route('hashtags.show', hashtag.toLowerCase());
            },

            // Auto link @mention to public profile
            mention: function (val) {
                var username = val.substr(1); // strip leading @
                return window.route('public-profile.show', username);
            },

        },
    };

    // enforce that provided html is escaped
    if(escapeHtml){
        return linkifyString(html, config);
    }

    // provided html is allowed to be rendered
    return linkifyHtml(html, config);

};

/**
 * Linkify links in the provided html. This does not prevent XSS, but we should only ever provide html from an
 * element that already exists in the dom, and never user provided text.
 * @param html
 * @param typesString
 * @returns {string}
 */
window.linkifyHtml = function(html, typesString) {
    return linkify(html, typesString, false);
};

/**
 * Linkify links in the provided string making sure any html in the provided string is escaped first.
 * This will return html that should be rendered, and any unsafe html in the provided string should be automatically
 * neutralized by the linkifyString library to prevent xss.
 * @param string
 * @param typesString
 * @returns {string}
 */
window.linkifyString = function(string, typesString) {
    return linkify(string, typesString, true);
};

// linkify all elements on the page that have a data attribute of 'data-linkify'.
window.addEventListener('load', function() {
    var elements = document.querySelectorAll('[data-linkify]');
    elements.forEach(function(element) {

        // get types from data attribute
        var types = element.getAttribute('data-linkify');

        // linkify element
        element.innerHTML = window.linkifyHtml(element.innerHTML, types);

    });
});
